Ext.ux.IFrameComponent = Ext.extend(Ext.BoxComponent, {
    url: null,
    onRender : function(ct, position) {
        this.el = ct.createChild({tag: 'iframe', id: 'iframe-' + this.id, frameBorder: 0, src: this.url});
    },
    setUrl: function(url) {
        this.url = url;
    }
});
Ext.reg('iframe', Ext.ux.IFrameComponent);